import { Link } from "react-router-dom";
import { LOGO_URL, WHATSAPP_NUMBERS } from "../lib/api";
import { MessageCircle } from "lucide-react";
import { track } from "../lib/track";

export function Header({ transparent, contact = true }) {
  const waMsg = encodeURIComponent("Ciao Fantini Next Mobility! Vorrei alcune informazioni.");
  return (
    <header
      data-testid="site-header"
      className={`fixed top-0 left-0 right-0 z-40 ${transparent ? "" : "glass border-b border-border"}`}
    >
      <div className="w-full px-5 md:px-10 h-20 md:h-24 flex items-center justify-between">
        <Link to="/" data-testid="logo-link" className="flex items-center">
          <img src={LOGO_URL} alt="Fantini Next Mobility" className="h-[58px] md:h-[77px] w-auto object-contain" />
        </Link>
        {contact && (
          <a
            href={`https://wa.me/${WHATSAPP_NUMBERS[0].number}?text=${waMsg}`}
            target="_blank"
            rel="noreferrer"
            data-testid="header-contact-btn"
            onClick={() => track("click_whatsapp", { label: "header" })}
            className="inline-flex items-center gap-2 px-5 py-2.5 rounded-full bg-ink text-white text-sm hover:opacity-90 transition-opacity"
          >
            <MessageCircle size={15} strokeWidth={1.5} className="text-[#68b39d]" />
            <span className="hidden sm:inline">WhatsApp</span>
          </a>
        )}
      </div>
    </header>
  );
}
